import { useRef } from 'react'

import { BodyM, HeadingS } from '@/components/Typography'

import { useRemountEffect } from '@/hooks/useRemountEffect'

import ToggleSwitch from '../../../Input/ToggleSwitch/ToggleSwitch'
import { useFgtsLoanSimulator } from '../../core/context'

import { getSwitchLabel } from '../../core/utils'
import { Cta as Button, ButtonsWrapper } from '../styles'

import { FgtsField } from './FgtsField'
import { SalaryField } from './SalaryField'
import * as Simulation from './styles'

const SimulationForm = () => {
  const { birthDateRef, hasFgts, onToggleIncomeType, handleOnSubmit } = useFgtsLoanSimulator()
  const ValueFieldComponent = hasFgts ? FgtsField : SalaryField
  const shouldFocus = useRef<boolean>(false)
  const switchLabel = getSwitchLabel(hasFgts)

  useRemountEffect(() => {
    shouldFocus.current = true
  })

  return (
    <Simulation.Form onSubmit={handleOnSubmit}>
      <HeadingS html="Qual é a data do seu aniversário?" />
      <BodyM html="Informe o dia, mês e ano da sua data de nascimento:" />

      <Simulation.DateField
        allowFuture={false}
        aria-label="Digite a sua data de aniversário no formato"
        placeholder="dia/mês/ano"
        ref={birthDateRef}
        required
      />

      <ToggleSwitch
        label="Sei o valor que eu tenho no FGTS"
        checked={hasFgts}
        aria-label={switchLabel}
        onChange={onToggleIncomeType}
      />

      <ValueFieldComponent shouldFocus={shouldFocus.current && hasFgts} />

      <ButtonsWrapper>
        <Button
          type="submit"
          modifier="solid"
          event={{
            label: `Simular agora ${hasFgts ? 'sei' : 'não sei'} o valor que tenho no FGTS`,
          }}
        >
          Simular agora
        </Button>
      </ButtonsWrapper>
    </Simulation.Form>
  )
}

export default SimulationForm
